// src/services/CategoryService.js

import { 
  collection, 
  doc, 
  setDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  getDoc, 
  getDocs, 
  query, 
  orderBy, 
  Timestamp 
} from "firebase/firestore";
import { db } from "../firebase";

const CATEGORIES_COLLECTION = "categories";

// Create a new category
export const createCategory = async (categoryData) => {
  try {
    const docRef = await addDoc(collection(db, CATEGORIES_COLLECTION), {
      ...categoryData,
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now()
    });
    
    const newCategory = await getDoc(docRef);
    return { id: newCategory.id, ...newCategory.data() };
    
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};

// Update an existing category
export const updateCategory = async (categoryId, categoryData) => {
  try {
    const categoryRef = doc(db, CATEGORIES_COLLECTION, categoryId);
    const categoryDoc = await getDoc(categoryRef);
    
    if (!categoryDoc.exists()) {
      throw new Error("Category not found");
    }
    
    await updateDoc(categoryRef, {
      ...categoryData,
      updatedAt: Timestamp.now()
    });
    
    const updatedCategory = await getDoc(categoryRef);
    return { id: updatedCategory.id, ...updatedCategory.data() };
    
  } catch (error) {
    console.error("Error updating category:", error);
    throw error;
  }
};

// Delete a category
export const deleteCategory = async (categoryId) => {
  try {
    const categoryRef = doc(db, CATEGORIES_COLLECTION, categoryId);
    const categoryDoc = await getDoc(categoryRef);
    
    if (!categoryDoc.exists()) {
      throw new Error("Category not found");
    }
    
    await deleteDoc(categoryRef);
    return true;
    
  } catch (error) {
    console.error("Error deleting category:", error);
    throw error;
  }
};

// Get a single category by ID
export const getCategoryById = async (categoryId) => {
  try {
    const categoryRef = doc(db, CATEGORIES_COLLECTION, categoryId);
    const categoryDoc = await getDoc(categoryRef);
    
    if (!categoryDoc.exists()) {
      throw new Error("Category not found");
    }
    
    return { id: categoryDoc.id, ...categoryDoc.data() };
    
  } catch (error) {
    console.error("Error getting category:", error);
    throw error;
  }
};

// Get all categories
export const getAllCategories = async () => {
  try {
    const q = query(collection(db, CATEGORIES_COLLECTION), orderBy("name", "asc"));
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
  } catch (error) {
    console.error("Error getting all categories:", error);
    throw error;
  }
};